import './Utils/domRemoveChildFix.js' // muss VOR React laufen (patcht Node.prototype)
import './style.css'
import ReactDOM from 'react-dom/client'
import Experience from './Experience.jsx'
import ErrorBoundary from './Utils/ErrorBoundary.jsx'




const root = ReactDOM.createRoot(document.querySelector('#root'))



root.render(
    <>


<ErrorBoundary>
<Experience />
</ErrorBoundary>
        </>

)

